import { GLTYC4 } from "./CGUTranslation";
import { GLTYC3 } from "./PPDTranslation";
import { GL1 } from "./translations1";
import { GL2 } from "./translations2";
import { GLTYC1 } from "./TycsTranslation1";
import { GLTYC2 } from "./TycsTranslation2";

const GL = { ...GL1, ...GL2, ...GLTYC1, ...GLTYC2, ...GLTYC3, ...GLTYC4 };
export { GL };